<template>
  <!--<div>-->
  <div class="partnersMain">
    <!--banner+导航-->
    <div class="bannerBox">
      <img ref="homeBanner" src="../../../assets/img/aboutBanner.jpg" />
      <div class="topTextBox">
        <!--导航-->
        <top-nav></top-nav>
        <!--<top-nav :nav-index1="6"></top-nav>-->
      </div>
    </div>
    <div class="servicesContent">
      <div class="contentW">
        <div class="services01" id="m1">
          <div style="width: 100%; margin: auto; min-width: 62.5rem;">
            <!-- <div class="leftBox animated" :class="animates.mm1 ? 'fadeInUp' : 'hideBox'"><img src="../../../assets/icon/servicesImg1.png"/><div class="box"></div></div> -->
            <div
              class="rightBox animated"
              :class="animates.mm1 ? 'fadeInUp' : 'hideBox'"
            >
              <div class="titles">Privacy & Disclosure</div>
              <div
                class="contents"
                @click="linkDownload('/static/privacy1.pdf')"
              >
                <img
                  style="margin-bottom: -5px;"
                  src="../../../assets/icon/group1.png"
                />
                Privacy Policy
              </div>
              <div
                class="contents2"
                @click="linkDownload('/static/privacy2.pdf')"
              >
                <img
                  style="margin-bottom: -5px;"
                  src="../../../assets/icon/group1.png"
                />
                Product Disclosure and Financial Services Guide
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--底部-->
    <Footer></Footer>
  </div>
  <!--</div>-->
</template>

<script>
import topNav from "./nav";
import Footer from "@/components/Footer";
let timer = null; //定义初始值
export default {
  name: "privacy",
  components: { topNav, Footer },
  props: {
    step: {
      //此数据是控制动画快慢的
      type: Number,
      default: 50,
    },
  },
  data() {
    return {
      animates: {
        mm1: false,
        mm2: false,
        mm3: false,
        mm4: false,
        mm5: false,
      },
    };
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //监听页面滚动事件
  },
  mounted() {
    document.documentElement.scrollTop = 0;

    this.animates.mm1 = true;
    if (window.innerWidth > 1200) {
      window.addEventListener("scroll", this.handleScroll);
    } else {
      this.animates.mm2 = true;
      this.animates.mm3 = true;
      this.animates.mm4 = true;
      this.animates.mm5 = true;
    }
  },
  methods: {
    //  点击导航
    navClick(url) {
      this.$router.push(url);
    },
    //打开新连接
    linkDownload(url) {
      window.open(url, "_blank"); // 新窗口打开外链接
    },

    handleScroll() {
      // var scrollTop =
      //   window.pageYOffset ||
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop;

    },

    //置顶
    toTop() {
      // 动画

      timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        // this.isTop = true
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
  },
};
</script>

<style scoped>
body {
  min-width: 1345px;
}

.partnersMain {
  width: 100%;
  height: auto;
}
.partnersMain .bannerBox {
  width: 100%;
  height: 600px;
  position: relative;
}
.partnersMain .bannerBox > img {
  width: 100%;
  height: 600px;
}
.partnersMain .bannerBox .topTextBox {
  width: 100%;
  height: 600px;
  position: absolute;
  top: 0;
  left: 0;
}

/*内容部分*/
.servicesContent {
  width: 100%;
  height: auto;
  padding: 2rem 0 0rem 0;
  background-color: #fff;
}

/*模块1*/
.services01 {
  width: 100%;
  height: auto;
  overflow: hidden;
  border-bottom: 1px solid #979797;
  padding-top: 5rem;
}
.services01 .leftBox {
  width: 50%;
  height: 100%;
  float: left;
  text-align: left;
  position: relative;
}
.services01 .leftBox > img {
  width: 360px;
  padding-left: 25%;
}
.services01 .leftBox > .box {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  background: -webkit-linear-gradient(
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.8)
  ); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.8)
  ); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.8)
  ); /* Firefox 3.6 - 15 */
  background: linear-gradient(
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.8)
  ); /* 标准的语法 */
}
.services01 .rightBox {
  width: calc(50% - 30px);
  height: 600px;
  float: left;
}
.services01 .rightBox .titles {
  font-size: 24px;
  font-family: OpenSans-Bold, OpenSans;
  font-weight: bold;
  color: rgba(74, 74, 74, 1);
  line-height: 33px;
  margin-bottom: 10px;
  /* font-size: 2.25rem;
  font-family: MontserratRegular;
  color: #4a4a4a;
  line-height: 3rem;
  margin-top: 0rem; */
}
.services01 .rightBox .contents {
  height: 24px;
  font-size: 14px;
  font-family: Montserrat-Regular, Montserrat;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  line-height: 24px;
  cursor: pointer;
  /* font-size: 1.25rem;
  font-family: Montserrat300;
  color: #4a4a4a;
  line-height: 1.8rem;
  margin-top: 2rem;
  margin-bottom: 5rem; */
}
.services01 .rightBox .contents2 {
  height: 24px;
  font-size: 14px;
  font-family: Montserrat-Regular, Montserrat;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  line-height: 24px;
  cursor: pointer;
  margin-top: 12px;
  /* font-size: 1.25rem;
  font-family: Montserrat300;
  color: #4a4a4a;
  line-height: 1.8rem;
  margin-top: -5rem;
  margin-bottom: 5rem; */
}
.services01 .rightBox .btn {
  font-size: 0.97rem;
  width: 8rem;
  font-family: MontserratMedium;
  text-align: center;
  color: #4a4a4a;
  height: 2.7rem;
  line-height: 2.7rem;
  margin-top: 2rem;
  border: 1px solid #4a4a4a;
  border-radius: 4px;
  cursor: pointer;
}

/*模块2*/
.services02 {
  width: 100%;
  height: auto;
  overflow: hidden;
  padding-top: 53px;
}
.services02 .leftBox {
  width: calc(50% - 30px);
  height: 100%;
  float: right;
  text-align: center;
  position: relative;
}
.services02 .leftBox > img {
  width: 468px;
}
.services02 .rightBox {
  width: calc(50% + 30px);
  height: 100%;
  float: left;
}
.services02 .rightBox .titles {
  font-size: 2.25rem;
  font-family: MontserratRegular;
  color: #4a4a4a;
  line-height: 3rem;
  margin-top: 5rem;
  margin-left: 25%;
}
.services02 .rightBox .contents {
  font-size: 1.25rem;
  font-family: Montserrat300;
  color: #4a4a4a;
  line-height: 1.8rem;
  margin-top: 2rem;
  margin-left: 25%;
}
.services02 .rightBox .btn {
  font-size: 0.97rem;
  width: 8rem;
  font-family: MontserratMedium;
  text-align: center;
  color: #4a4a4a;
  height: 2.7rem;
  margin-left: 25%;
  line-height: 2.7rem;
  margin-top: 2rem;
  border: 1px solid #4a4a4a;
  border-radius: 4px;
  cursor: pointer;
}

/*模块3*/
.services03 {
  width: 100%;
  height: auto;
  padding: 5rem 0;
  background-color: #f6f6f6;
}
.services03 .titles {
  padding-top: 2rem;
  width: 100%;
  height: 5rem;
  line-height: 5rem;
  font-family: Montserrat300;
  font-size: 1.5rem;
  text-align: center;
  border-bottom: 1px solid #979797;
}
.services03 .contentUl {
  width: calc(100% - 4rem);
  height: 13.75rem;
  overflow: hidden;
  padding: 3rem 2rem;
}
.services03 .contentUl > li {
  float: left;
  width: 33.33%;
  height: 100%;
}
.services03 .contentUl > li .iconBox {
  width: 6rem;
  height: 100%;
  float: left;
  text-align: center;
}
.services03 .contentUl > li .textBox {
  width: calc(90% - 6rem);
  min-width: 17.5rem;
  float: left;
  height: 100%;
}
.services03 .contentUl > li .textBox .titleText {
  width: 100%;
  height: auto;
  font-family: Montserrat600;
  font-size: 1rem;
  color: #4a4a4a;
  line-height: 3rem;
}
.services03 .contentUl > li .textBox .contentText {
  width: 100%;
  height: auto;
  font-family: Montserrat300;
  font-size: 0.875rem;
  color: #4a4a4a;
  line-height: 1.8rem;
}

.hideBox {
  display: none;
}
.uline {
  /* height:1px; */
  margin-top: 10px;
  border-bottom: #4a4a4a 1px solid;
}
.privacy {
  /* border-top: #4a4a4a 1px solid; */
  margin-top: 10px;
}
.contents a {
  text-decoration: none;
  color: rgba(74, 74, 74, 1);
}
.contents2 a {
  text-decoration: none;
  color: rgba(74, 74, 74, 1);
}
</style>
